import React from "react";
import "./ConfigurePanel.css";
import configurePanelImg from "../../../../assets/configure-panel.svg"; // Assuming you have an image for the panel

export const ConfigurePanel = () => {
  return (
    <div className="configure-panel-container">
      <div className="configure-panel-info-container">
        <img style={{ maxWidth: "500px" }} src={configurePanelImg} />
        <div className="configure-panel-text">
          <h2>Your Panel has been created!</h2>
          <p>Now let's configure the information you want to visualize.</p>
          <p className="info">Click bellow to start setting up the panel</p>
        </div>
      </div>
      <button className="configure-panel-button">Configure Panel</button>
    </div>
  );
};
